
<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 v-if="cur_item.id > 0">
                    <span class="fw-300">ID:{{this.cur_item.id}} | {{this.cur_item.zal}}</span>
                </h2>
                
                <h2 v-else>
                    -
                </h2>
                
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <div class="reserv_info">
                    <div class="info_time">
                        <div class="block">
                            <div class="title ">ПІБ</div>
                            <div class="action">
                               {{this.cur_item.name}}
                            </div>
                            <div class="clr"></div>
                        </div>
                        
                        <div class="block">
                            <div class="title ">Комент</div>
                            <div class="action">
                                {{this.cur_item.coment}}
                            </div>
                            <div class="clr"></div>
                        </div>
                        
                        <div class="block">
                            <div class="title ">Початок Бронювання</div>
                            <div class="action">
                                {{this.cur_item.date_pick}}
                            </div>
                            <div class="clr"></div>
                        </div>
                        
                        <div class="block">
                            <div class="title ">Кiнець Бронювання</div>
                            <div class="action">
                                {{this.cur_item.date_end}}
                            </div>
                            <div class="clr"></div>
                        </div>
                        
                        
                    </div>
                </div>
            </div>
            <!--FOOTER -->
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                
                <button type="button" v-on:click="remove_reservation" class="btn btn-outline-danger waves-effect waves-themed">
                    Видалити
                </button>
                
                <button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "conference_modal",
    
    created() {
        EventBus.$on('show_conference_info',this.show_item)
    },
    
    data() {
        return {
            is_load : false,
            is_show_modal : false,
            cur_item : {
                "id" : 0,
            }
        }
    },
    
    methods : {
        
        show_item(item) {
            this.is_show_modal = true;
            this.load_item_info(item);
        },
        
        async load_item_info(item) {
            this.cur_item = {
                id : 0,
            };
            await api.get('/conference/' + item.id).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    this.cur_item = data.data;
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        },
        
        async remove_reservation() {
            this.is_load = true;
            let self = this;
            
            await api.delete('/conference/' + this.cur_item.id).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    self.$emit('reload');
                    self.close();
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        },
        
        close_mod() {
            this.close();
        },
        
        close() {
            this.cur_item = {
                id : 0,
            };
            this.is_show_modal = false;
            
        },
    },
    
    computed : {
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }
            
            return "modal-dialog-left modal-lg";
        },
        
    }
}
</script>

<style scoped>

</style>